import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ItemDetailViewSection, {
  Item,
} from "../../../common/item/ItemDetailViewSection";
import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import { getById } from "../../../store/receipt/queries";
import { Data } from "../../../store/receipt/types";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";
import { fetchRequest as fetchReceipt } from "../../../store/receipt/actions";

const ReceiptView = () => {
  const classes = pageStyles();
  const session = useSession();
  const dispatch = useDispatch();

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      dispatch(fetchReceipt(id));
    }
  }, []);

  const receiptData = useSelector(id ? getById(id) : () => null);
  const at = receiptData?.attributes || ({} as Data);

  const receiptInfo: Item[] = [
    {
      fieldName: "Name",
      // @ts-ignore
      fieldValue: at.Name,
    },
    {
      fieldName: "For",
      // @ts-ignore
      fieldValue: at.For,
    },
    {
      fieldName: "Default",
      // @ts-ignore
      fieldValue: at.Default,
    },
  ];

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View Receipt" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Box style={{ position: "relative" }}>
                  <ItemDetailViewSection
                    sectionName="Receipt Info"
                    itemData={receiptInfo}
                  />
                </Box>

                {
                  // @ts-ignore
                  at.HTML && at.Type === "HTML" && (
                    <Box style={{ position: "relative" }}>
                      <Paper elevation={0} className={classes.sectionWrapper}>
                        <Grid
                          item
                          xs={12}
                          sm
                          className={classes.sectionHeading}
                        >
                          <Typography
                            variant="h5"
                            display="block"
                            className={classes.sectionHeadingTitle}
                          >
                            Receipt Preview
                          </Typography>
                        </Grid>
                        <Grid container justifyContent="center">
                          <Box
                            sx={{ p: 2, m: 2 }}
                            border={0.5}
                            borderRadius={4}
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                // @ts-ignore
                                __html: at.HTML || "",
                              }}
                            ></div>
                          </Box>
                        </Grid>
                      </Paper>
                    </Box>
                  )
                }
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default ReceiptView;
